(function() {
    $(document).ready(function() {
        const oIpss = $.extend(true, {}, window.c24.lp.ipssReforged);
        oIpss.isWidgetPrefilledWithLastSearchData = true;
        oIpss.prefilledLabelsKeys = {
            'depositAmount': 'depositAmount',
            'depositType': 'depositType',
        };

        oIpss.filterChipLabelMap.offer = {
            'singular': 'Antrag',
            'plural': 'Anträge',
        };

        oIpss.bPriceInCents = false;

        oIpss.tileHeadlineMap.incompleteContract = 'Antrag vervollständigen';
        oIpss.tileHeadlineMap.offer = 'Ihr letzter Antrag';
        oIpss.tileHeadlineMap.contract = 'Ihr letzter Vertrag';

        oIpss.bWholeTileClickable = false;

        oIpss.renderHeadline = function(data) {
            if (!oIpss.bUseTilesLayout) { // remove when all ipss are tiles layout
                const self = this;
                let amountHeadline;
                let typeHeadline;
                let amountHeadlineExtend = '';
                let newHeadline;
                const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', self.domContext);
                const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', self.domContext);
                const iAmountNonContracts = data.contracts ? data.contracts.length : 0;
                const iAmountLastSearches = data.lastSearches ? data.lastSearches.length : 0;
                const iAmountTotal = iAmountNonContracts + iAmountLastSearches;
                let bContractsOnly = false;

                if (!self.isValidApiResponse(data)) {
                    newHeadline = {};

                    newHeadline.general = 'Meine letzte Aktivität';
                    newHeadline.lastSearches = 'Meine letzten Vergleiche';
                } else {

                    newHeadline = {};

                    if (data.contracts && iAmountNonContracts > 0) {

                        if (iAmountLastSearches > 0) {
                            typeHeadline = 'Aktivität';
                        } else {
                            bContractsOnly = true;

                            if (iAmountNonContracts > 1) {
                                typeHeadline = 'Anträge';
                            } else {
                                typeHeadline = 'Antrag';
                            }
                        }

                        if (iAmountTotal < 2) {
                            if (bContractsOnly) {
                                amountHeadline = 'Mein letzter ';
                            } else {
                                amountHeadline = 'Meine letzte ';
                                amountHeadlineExtend = '';
                            }
                        } else {
                            if (bContractsOnly) {
                                amountHeadline = 'Meine letzten ';
                                amountHeadlineExtend = '';
                            } else {
                                amountHeadline = 'Meine letzten ';
                                amountHeadlineExtend = 'en';
                            }
                        }

                        newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }

                    if (data.lastSearches) {

                        typeHeadline = 'Vergleich';

                        if (data.lastSearches.length < 2) {
                            amountHeadline = 'Mein letzter ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'e';
                        }

                        newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }
                }

                if (self.bShowContracts) {
                    if (iAmountNonContracts < 1 && data.lastSearches) {
                        newHeadline.general = newHeadline.lastSearches;
                        newHeadline.lastSearches = null;
                    }

                    $tabHeadlineLastSearches.text(newHeadline.general);

                    if (newHeadline.lastSearches === null) {
                        $headlineShowEverything.remove();
                    } else {
                        $headlineShowEverything.text(newHeadline.lastSearches);
                    }

                } else {
                    $('[id^="lastSearches"] .ipssHeadline:not(.showEverything)', self.domContext).text(newHeadline.general);
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }
            } else {
                const self = this;
                let amountHeadline;
                let typeHeadline;
                let amountHeadlineExtend = '';
                const newHeadline = {};
                const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', self.domContext);
                const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', self.domContext);

                self.iAmountNonContracts = data.contracts ? data.contracts.length : 0;
                self.iAmountLastSearches = data.lastSearches ? data.lastSearches.length : 0;
                self.iAmountTotal = self.iAmountNonContracts + self.iAmountLastSearches;

                if (!self.isValidApiResponse(data)) {

                    newHeadline.general = 'Meine letzte Aktivität';
                    newHeadline.lastSearches = 'Meine letzten Vergleiche';
                } else {
                    if (data.contracts && self.iAmountNonContracts > 0) {

                        typeHeadline = 'Aktivität';

                        if (self.iAmountTotal < 2) {
                            amountHeadline = 'Meine letzte ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'en';
                        }

                        newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }

                    if (data.lastSearches) {

                        typeHeadline = 'Vergleich';

                        if (data.lastSearches.length < 2) {
                            amountHeadline = 'Mein letzter ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'e';
                        }

                        newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }
                }

                if (self.bShowContracts) {

                    if (self.iAmountNonContracts < 1 && data.lastSearches) {
                        newHeadline.general = newHeadline.lastSearches;
                        newHeadline.lastSearches = null;
                    }

                    $tabHeadlineLastSearches.text(newHeadline.general);

                    if (newHeadline.lastSearches === null && self.aAppointmentsGrouped?.length < 0) {
                        $headlineShowEverything.remove();
                    } else {
                        $headlineShowEverything.text(newHeadline.lastSearches);
                    }

                } else {
                    $('[id^="lastSearches"] .ipssHeadline.nonContracts', self.domContext).text(newHeadline.general);
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }

                if (self.bUseTilesLayout && self.bIsMobile) {
                    $('.ipssHeadline.activities', self.domContext).text(`Meine Aktivitäten (${self.iAmountTotal})`);
                }
            }
        };

        oIpss.renderDataArrayProductSpecificTileHeadline = function(sRenderType, data) {
            if (sRenderType === 'offer' && data?.completed === false) {
                return 'Antrag vervollständigen';
            }

            return false;
        };

        oIpss.renderProductSpecificLabels = function (data, sRenderType) {
            const labels = { };
            const dataInputs = data.inputs;
            let depositTypeMap = {
                'NEW': 'Neue Kaution hinterlegen',
                'EXISTING': 'Hinterlegte Kaution ablösen',
            };

            if (sRenderType === 'contract') {
                depositTypeMap = {
                    'NEW': 'Hinterlegte Kaution',
                    'EXISTING': 'Abgelöste Kaution',
                };
            }
            const usageTypeMap = {
                'EXCLUSIVELY_PRIVATE': 'ausschließlich private Wohnnutzung',
                'MOSTLY_PRIVATE': 'überwiegend private Wohnnutzung',
            };

            if (!data.inputs) {
                return labels;
            }

            if (dataInputs.depositAmount) {
                labels.depositAmount = oIpss.formatPrice(dataInputs.depositAmount, 'euro', false, oIpss.bPriceInCents, true);
            } else {
                labels.depositAmount = null;
            }

            if (dataInputs.depositType) {
                labels.depositType = depositTypeMap[dataInputs.depositType] || null;
            } else {
                labels.depositType = null;
            }

            if (dataInputs.usageType) {
                labels.usageType = usageTypeMap[dataInputs.usageType] || null;
            } else {
                labels.usageType = null;
            }

            if (dataInputs.paymentPeriod) {
                labels.paymentPeriod = oIpss.periodMap[dataInputs.paymentPeriod];
            } else {
                labels.paymentPeriod = null;
            }

            return labels;
        };

        oIpss.renderLabels = function(element, data) {
            if (data.labels.priceMin == null && data.labels.priceMax == null) {
                $('.priceContainer', element).remove();
            }

            $.each(data.labels, function(key, value) {
                if (value != null) {
                    $('.' + key, element).html($.parseHTML(value));
                } else {
                    if (key === 'tariffName') {
                        $('.tariffSeparator', element).remove();
                    }
                    $('.' + key, element).remove();
                    $('.' + key + 'Container', element).remove();
                }
            });
        };

        oIpss.overrideData = {
            'version': 2,
            'lastUpdate': 1737975392670,
            'lastSearches': [
                {
                    'deviceOutput': 'desktop',
                    'time': 1737975376897,
                    'result': {
                        'cta': {
                            'text': 'Vergleich anzeigen',
                            'type': 'primary',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        'tariff': {
                            'best': {
                                'period': 'yearly',
                                'price': 64.5,
                            },
                        },
                        'inputs': {
                            'depositType': 'NEW',
                            'usageType': 'EXCLUSIVELY_PRIVATE',
                            'depositAmount': 1500,
                            'paymentPeriod': 'yearly',
                            'fittingTariffs': 7,
                        },
                        'urlDelete': 'https://urlDelete',
                    },
                },
            ],
            'contracts': [
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1728571035882,
                    'type': 'offer',
                    'completed': true,
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'MKV-2179986',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'yearly',
                        'name': 'Basis-Tarif',
                        'price': 67.5,
                    },
                    'insuranceKey': 'protect_versicherung',
                    'inputs': {
                        'depositType': 'NEW',
                        'usageType': 'EXCLUSIVELY_PRIVATE',
                        'depositAmount': 1500,
                        'paymentPeriod': 'yearly',
                        'fittingTariffs': 1,
                    },
                },
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1728388128603,
                    'type': 'offer',
                    'completed': true,
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'MKV-2177212',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'yearly',
                        'price': 66,
                    },
                    'insuranceKey': 'basler',
                    'inputs': {
                        'depositType': 'NEW',
                        'usageType': 'EXCLUSIVELY_PRIVATE',
                        'depositAmount': 1500,
                        'paymentPeriod': 'yearly',
                        'fittingTariffs': 1,
                    },
                },
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1728388015125,
                    'type': 'offer',
                    'completed': true,
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'MKV-2177187',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'yearly',
                        'price': 67.5,
                    },
                    'insuranceKey': 'wuerttembergische',
                    'inputs': {
                        'depositType': 'NEW',
                        'usageType': 'EXCLUSIVELY_PRIVATE',
                        'depositAmount': 1500,
                        'paymentPeriod': 'yearly',
                        'fittingTariffs': 1,
                    },
                },
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1728386798195,
                    'type': 'offer',
                    'completed': true,
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'MKV-2177109',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'yearly',
                        'price': 66,
                    },
                    'insuranceKey': 'allianz',
                    'inputs': {
                        'depositType': 'NEW',
                        'usageType': 'EXCLUSIVELY_PRIVATE',
                        'depositAmount': 1500,
                        'paymentPeriod': 'yearly',
                        'fittingTariffs': 1,
                    },
                },
                {
                    'status': {
                        'text': 'aktiv: seit 11.10.2024',
                        'color': 'green',
                    },
                    'time': 1728572521465,
                    'type': 'contract',
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'MK202410101YXCAPO',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'zur Vertragsübersicht',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'yearly',
                        'name': 'Basis-Tarif',
                        'price': 67.5,
                    },
                    'insuranceKey': 'protect_versicherung',
                    'inputs': {
                        'depositType': 'NEW',
                        'usageType': 'EXCLUSIVELY_PRIVATE',
                        'depositAmount': 1500,
                        'paymentPeriod': 'yearly',
                        'fittingTariffs': 1,
                    },
                },
            ],
            'staticTiles': [
                {
                    'cta': [
                        {
                            'text': 'jetzt Vertrag hinzufügen',
                            'type': 'primary',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                    ],
                    'time': 1737975392684,
                    'deviceOutput': 'desktop',
                    'subHeadline': 'Nicht bei uns abgeschlossen?',
                    'logo': 'https://mietkaution.check24-test.de/content/foreign_contract_icon.svg',
                    'textLine1': 'Vertrag digitalisieren',
                    'textLine2': 'Keine Frist verpassen',
                    'textLine3': 'Günstigeres Angebot finden',
                },
            ],
        };

        oIpss.bind('mkv', 'https://mietkaution' + window.c24LpDomain + '/ap-ipss-api/MKV/v2', $('.mod24ac.mkv'));
    });
})();
